import React from "react";
import Button from "components/ui/Button";

const NavigationControls = ({
  currentIndex,
  totalQuestions,
  hasAnswer,
  onPrev,
  onNext,
  onSubmit,
}) => {
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === totalQuestions - 1;

  return (
    <div className="flex items-center justify-between gap-3 mt-4 md:mt-6">
      <Button
        variant="outline"
        size="default"
        disabled={isFirst}
        onClick={onPrev}
        iconName="ChevronLeft"
        iconPosition="left"
      >
        Précédent
      </Button>

      <span
        className="font-mono text-xs hidden sm:block"
        style={{ color: "var(--color-muted-foreground)" }}
      >
        {currentIndex + 1} / {totalQuestions}
      </span>

      {isLast ? (
        <Button
          variant="success"
          size="default"
          onClick={onSubmit}
          iconName="CheckCircle"
          iconPosition="right"
        >
          Terminer le QCM
        </Button>
      ) : (
        <Button
          variant="default"
          size="default"
          onClick={onNext}
          iconName="ChevronRight"
          iconPosition="right"
        >
          Suivant
        </Button>
      )}
    </div>
  );
};

export default NavigationControls;